import { startsWith } from 'lodash/fp'

export default {
  functional: true,
  name: 'TableCellLink',
  props: ['value'],
  render (h, context) {
    const value = context.props.value

    const icon = <v-icon small color={'primary'}>mdi-launch</v-icon>

    const link = value && value.length
      ? startsWith('http')(value) || startsWith('//')(value)
        ? <a href={value} target={'_blank'} style={{ display: 'flex' }}>{value}{icon}</a>
        : startsWith('www')(value) || startsWith('WWW')(value)
          ? <a href={`https://${value}`} target={'_blank'} style={{ display: 'flex' }}>{value}{icon}</a>
          : <router-link to={value}>{value}{icon}</router-link>
      : null

    return (
      <td class="cell--link">
        {link}
      </td>
    )
  }
}
